import { render, staticRenderFns } from "./ModelAlertOverdueBalance.vue?vue&type=template&id=5b32561a&"
import script from "./ModelAlertOverdueBalance.vue?vue&type=script&lang=js&"
export * from "./ModelAlertOverdueBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports